module.exports = __webpack_public_path__ + "static/people-8f3f06144226cf8b6b8df1a37938ea08.png";